import type {AdLocation} from '@frontend/modules/public/ads/AdsModuleTypes'

// Проверить, выбрана ли локация?
export function isLocationSelected(
    location: AdLocation,
    selectedLocation?: AdLocation | null
): boolean {
    return (
        !!selectedLocation
        && (
            selectedLocation.id == location.id
            || selectedLocation.parentIds.includes(location.id)
        )
    )
}
